module.exports = __webpack_public_path__ + "assets/9a37d78c6ec142a8f13064a5e343c55a.mp3";